// A request dialog's error line. When the server says the profile must be
// finished first (Clear passage), it links there; the label is the profile
// page's own title (pages/Onboarding/Profile.jsx).
export default function RequestAlert({ error, finishProfile }) {
  if (!error) return null

  return (
    <p role="alert" className="text-[12.5px] text-destructive">
      {error}
      {finishProfile && (
        <>
          {" "}
          <a href={finishProfile} className="font-semibold underline">Finish your profile</a>
        </>
      )}
    </p>
  )
}
